import React from 'react'
import { JetSportBox } from '../BoxView/JetSportBox'
import { BoxContent } from '../BoxView/BoxContent'
import LoadingElement from '../loading-element/loading-element'
import { useWhiteLabelContext } from '../../../WhiteLabelContext'

export function LoadingView({ text }: { text?: string } = {}): React.ReactElement {
  const {whiteLabel: {colorHex}} = useWhiteLabelContext()
  return (
    <JetSportBox className={'!p-0'}>
      <BoxContent className={'justify-center items-center relative rounded !p-0 gap-3'}>
        <LoadingElement className={'rounded'} colorHex={colorHex} />
        {text && <p className={'text-sm text-gray-500'}>{text}</p>}
      </BoxContent>
    </JetSportBox>
  )
}
